var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-container',[_c('el-header',{attrs:{"height":_vm.navHeight}},[_c('Nav')],1),_c('el-main',[_c('Recruit',{key:_vm.componentKey})],1),_c('el-footer',{attrs:{"height":_vm.footerHeight}},[_c('Footer',{attrs:{"needPrivacy":false}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }